import { TimeSeriesRegistry } from '@/components/charts/timeSeriesAdapter.ts';
import { CHART_PALETTE } from '@/components/ui/chartPalette.ts';
import { registryLabel } from '@/types/stats/registryLabel.ts';

/** Serie krzywej zapisów, nazwy jak w wyliczeniu backendu. */
export enum SignupSeriesKey {
  CURRENT = 'CURRENT',
  FORECAST = 'FORECAST',
  BENCHMARK = 'BENCHMARK',
}

/**
 * Prognoza jest jaśniejsza niż benchmark, ale obie idą kreską przerywaną —
 * przerywana znaczy „wartość niepewna”, a nie „mniej ważna”.
 */
export const SIGNUP_SERIES_REGISTRY: TimeSeriesRegistry = {
  [SignupSeriesKey.CURRENT]: {
    label: 'Zapisani narastająco',
    color: CHART_PALETTE.accent,
    filled: true,
    emphasized: true,
  },
  [SignupSeriesKey.FORECAST]: {
    label: 'Prognoza przy tym tempie',
    color: CHART_PALETTE.muted,
    dashed: true,
  },
  [SignupSeriesKey.BENCHMARK]: {
    label: 'Średnia innych wyjazdów',
    color: CHART_PALETTE.reference,
    dashed: true,
  },
};

/** Metryki towarzyszące krzywej. Jedzie tylko w `sales`, nie w `summary`. */
export enum SignupMetricKey {
  BENCHMARK_TOUR_COUNT = 'BENCHMARK_TOUR_COUNT',
}

export const SIGNUP_METRIC_LABELS: Record<SignupMetricKey, string> = {
  [SignupMetricKey.BENCHMARK_TOUR_COUNT]: 'Wyjazdy porównawcze',
};

export const signupMetricLabel = (key: string): string =>
  registryLabel(SIGNUP_METRIC_LABELS, key, 'metryka krzywej zapisów');
